import TextArea from 'antd/es/input/TextArea'
import React from 'react'
import { Card, Col, Input, theme } from 'antd'
import CustomRow from '../../../reusable-components/CustomRow'
import { hexToRGBA } from '../../../lib/utils'

const GeneralForm = ({ isMonitoring, data, setData, planType, planLabel }) => {
  const { token } = theme.useToken()

  // Display the correct plan type in UI
  const displayLabel =
    planLabel || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) + ' Plan' : 'Care Plan')

  return (
    <Card>
      <h1 style={{ color: token.colorPrimary }}>
        NEW {isMonitoring ? 'MONITORING' : ''} {displayLabel.toUpperCase()}
      </h1>
      <p>
        Please provide basic details for your {isMonitoring ? 'monitoring' : ''} {displayLabel.toLowerCase()}.
      </p>
      <Card
        size='small'
        headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
        style={{ marginTop: 12 }}
        title='General'
      >
        <CustomRow>
          <Col span={24}>
            <p>Name:</p>
            <Input
              value={data?.name}
              style={{ width: 500 }}
              placeholder={`- ${isMonitoring ? 'Monitoring' : ''} ${displayLabel} Name -`}
              onChange={(e) => {
                setData({ ...data, name: e.target.value })
              }}
            />
          </Col>
          <Col span={24}>
            <p>Description:</p>
            <TextArea
              value={data.description}
              onChange={(e) => {
                setData({ ...data, description: e.target.value })
              }}
              rows={4}
              placeholder={`- ${isMonitoring ? 'Monitoring' : ''} ${displayLabel} Description -`}
            />
          </Col>
        </CustomRow>
      </Card>
    </Card>
  )
}

export default GeneralForm
